<style lang="scss" scoped>
img {
  transition: transform .2s;
  &:hover {
    box-shadow: 1px 4px 9px #000;
    transform: scale(2.5);
  }
}
.imagebank {
  border-left: #000 solid 40px;
  border-right: #000 solid 40px;
  height: 89%;
  margin-top: 5%;
  margin-left: 0;
  margin-right: 0;
  overflow: auto;
  @media screen and (max-width: 768px) {
    height: 82%;
    &.active-category {
      height: 69%;
      margin-top: -10px;
    }
  }
}
</style>
<template>
  <div
    class="frow content-start gutters imagebank"
    :class="{'active-category': activeCategory}"
  >
    <a
      v-for="(art, index) in filteredArt"
      :key="index"
      :href="`/art/${art.link}`"
      class="col-xs-1-3 col-md-2-12"
      @click.prevent="$emit('setActiveArt', art)"
    >
      <img
        v-if="art.imageUrl"
        :src="art.imageUrl"
        :style="{ 'max-height': settings.imageBankHeight }"
        :alt="art.altTag ? art.altTag : art.title"
      >
    </a>
  </div>
</template>

<script>
export default {
  name: 'ImageBank',
  props: {
    art: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => {},
    },
    activeCategory: {
      type: String,
      default: null,
    },
  },
  computed: {
    filteredArt() {
      return this.art.filter((art) => art.hidden != true);
    },
  },
};
</script>
